import { render, staticRenderFns } from "./GlossaryTermItem.vue?vue&type=template&id=7132b0f7"
import script from "./GlossaryTermItem.vue?vue&type=script&lang=js"
export * from "./GlossaryTermItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports